export const getMyOrders = "/requests/get-my-orders";